import { Fragment, useContext, useState } from "react";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import ProviderTypesList from "./ProviderTypesList";
import { menuRoutes } from "../../../router/menu";
import PageHeader from "../../../layout/shared/page-header";
import cn from "../../../utils/classNames";
import { Button } from "rizzui";
import { PrivilegeContext } from "../../../components/priviledge/PriviledgeProvider";
import { ProviderType } from "../../../type/entities/provider-type-type";

const ProviderTypesListWrapper = () => {

    // STATES

    const [isOpenFormDrawer, setIsOpenFormDrawer] = useState(false);
    const [providerTypeSelected, setProviderTypeSelected] = useState<ProviderType | null>(null);

    const breadCrumb = [
        { name: 'Administración' },
        { name: 'Gestión de tipos de proveedores' },
        { name: 'Tipos de proveedores', href: menuRoutes.providerTypes.path },
    ];

    const defaultFilters = {};

    // HOOKS 

    const { userCan } = useContext(PrivilegeContext);

    // RENDER

    return (
        <Fragment>
            <FiltersProvider defaultFilterFilters={defaultFilters} >
                <PageHeader title="Listado de tipos de proveedores" breadcrumb={breadCrumb}>
                     {
                        userCan('create', 'provider_type') &&
                        (
                            <Button
                                color="primary"
                                onClick={() => { 
                                    setIsOpenFormDrawer(true) 
                                    setProviderTypeSelected(null)
                                }}
                                className={cn(['mt-4 md:mt-0'])}
                            >
                                Crear tipo de proveedor
                            </Button>
                        )
                    }
                </PageHeader>
                <ProviderTypesList openFormDrawer={isOpenFormDrawer} setOpenFormDrawer={setIsOpenFormDrawer} providerTypeSelected={providerTypeSelected} setProviderTypeSelected={setProviderTypeSelected} />
            </FiltersProvider>
        </Fragment>
    );
};

export default ProviderTypesListWrapper;
